"use strict";

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SaleorState = void 0;

var round_1 = __importDefault(require("lodash/round"));

var helpers_1 = require("../helpers");

var LocalStorageHandler_1 = require("../helpers/LocalStorageHandler");

var types_1 = require("./types");

var Auth_1 = require("../jobs/Auth");

var Auth_2 = require("../api/Auth");

var defaultSaleorStateLoaded = {
  checkout: false,
  payment: false,
  signInToken: false,
  summaryPrices: false,
  user: false
};

var SaleorState = /*#__PURE__*/function (_helpers_1$NamedObser) {
  _inherits(SaleorState, _helpers_1$NamedObser);

  var _super = _createSuper(SaleorState);

  function SaleorState(config, localStorageHandler, apolloClientManager, jobsManager) {
    var _this;

    _classCallCheck(this, SaleorState);

    _this = _super.call(this);
    /**
     * Subscribes to particular changes occuring in data sources like apollo cache or local storage.
     * Every update in data source will result in update of respective class member.
     */

    _this.subscribeStateToChanges = function () {
      _this.localStorageHandler.subscribeToChange(LocalStorageHandler_1.LocalStorageItems.CHECKOUT, _this.onCheckoutUpdate);

      _this.localStorageHandler.subscribeToChange(LocalStorageHandler_1.LocalStorageItems.PAYMENT, _this.onPaymentUpdate);

      _this.localStorageHandler.subscribeToChange(LocalStorageHandler_1.LocalStorageItems.TOKEN, _this.onSignInTokenUpdate);

      _this.localStorageHandler.subscribeToChange(LocalStorageHandler_1.LocalStorageEvents.CLEAR, _this.onClearLocalStorage);

      _this.apolloClientManager.subscribeToUserChange(_this.onUserUpdate);

      _this.jobsManager.attachEventListener("auth", function (event, value) {
        if (event === Auth_1.AuthJobsEvents.SIGN_IN_TOKEN_REFRESHING) {
          _this.onSignInTokenRefreshUpdate(value);
        }
      });
    };
    /**
     * Initialize class members with cached or fetched data.
     */


    _this.initializeState = function (config) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!LocalStorageHandler_1.LocalStorageHandler.getSignInToken()) {
                  _context.next = 4;
                  break;
                }

                this.onSignInTokenVerifyingUpdate(true);
                _context.next = 4;
                return this.verityToken();

              case 4:
                this.onSignInTokenVerifyingUpdate(false);
                /**
                 * Proceed with state initialization.
                 */

                if (!config.loadOnStart.auth) {
                  _context.next = 8;
                  break;
                }

                _context.next = 8;
                return this.jobsManager.run("auth", "provideUser", undefined);

              case 8:
                if (!config.loadOnStart.checkout) {
                  _context.next = 12;
                  break;
                }

                _context.next = 11;
                return this.jobsManager.run("checkout", "provideCheckout", {
                  channel: config.channel,
                  isUserSignedIn: !!this.user
                });

              case 11:
                this.onPaymentUpdate(LocalStorageHandler_1.LocalStorageHandler.getPayment());

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };

    _this.verityToken = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _a, _yield$this$jobsManag, data, dataError;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.jobsManager.run("auth", "verifySignInToken", undefined);

              case 2:
                _yield$this$jobsManag = _context2.sent;
                data = _yield$this$jobsManag.data;
                dataError = _yield$this$jobsManag.dataError;

                if (!(dataError || !(data === null || data === void 0 ? void 0 : data.isValid))) {
                  _context2.next = 17;
                  break;
                }

                _context2.next = 8;
                return this.jobsManager.run("auth", "signOut", undefined);

              case 8:
                _context2.prev = 8;

                if (!((_a = navigator.credentials) === null || _a === void 0 ? void 0 : _a.preventSilentAccess)) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 12;
                return navigator.credentials.preventSilentAccess();

              case 12:
                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](8);
                // eslint-disable-next-line no-console
                console.warn(Auth_2.BROWSER_NO_CREDENTIAL_API_MESSAGE, _context2.t0);

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[8, 14]]);
      }));
    };

    _this.onLoadedUpdate = function (newLoaded) {
      _this.loaded = Object.assign(Object.assign({}, _this.loaded), newLoaded);

      _this.notifyChange(types_1.StateItems.LOADED, _this.loaded);
    };

    _this.onClearLocalStorage = function () {
      _this.onSignInTokenUpdate(null);

      _this.onUserUpdate(null);

      _this.onCheckoutUpdate();

      _this.onPaymentUpdate();
    };

    _this.onSignInTokenUpdate = function (token) {
      _this.signInToken = token;

      _this.notifyChange(types_1.StateItems.SIGN_IN_TOKEN, _this.signInToken);

      _this.onLoadedUpdate({
        signInToken: true
      });
    };

    _this.onSignInTokenVerifyingUpdate = function (tokenVerifying) {
      _this.signInTokenVerifying = tokenVerifying;

      _this.notifyChange(types_1.StateItems.SIGN_IN_TOKEN_VERIFYING, _this.signInTokenVerifying);
    };

    _this.onSignInTokenRefreshUpdate = function (tokenRefreshing) {
      _this.signInTokenRefreshing = tokenRefreshing;

      _this.notifyChange(types_1.StateItems.SIGN_IN_TOKEN_REFRESHING, _this.signInTokenRefreshing);
    };

    _this.onUserUpdate = function (user) {
      _this.user = user;

      _this.notifyChange(types_1.StateItems.USER, _this.user);

      _this.onLoadedUpdate({
        user: true
      });
    };

    _this.onCheckoutUpdate = function (checkout) {
      _this.checkout = checkout;
      _this.summaryPrices = SaleorState.calculateSummaryPrices(checkout);

      _this.notifyChange(types_1.StateItems.CHECKOUT, _this.checkout);

      _this.notifyChange(types_1.StateItems.SUMMARY_PRICES, _this.summaryPrices);

      _this.onLoadedUpdate({
        checkout: true,
        summaryPrices: true
      });
    };

    _this.onPaymentUpdate = function (payment) {
      _this.payment = payment;

      _this.notifyChange(types_1.StateItems.PAYMENT, _this.payment);

      _this.onLoadedUpdate({
        payment: true
      });
    };

    _this.localStorageHandler = localStorageHandler;
    _this.apolloClientManager = apolloClientManager;
    _this.jobsManager = jobsManager;
    _this.loaded = defaultSaleorStateLoaded;

    _this.onSignInTokenUpdate(LocalStorageHandler_1.LocalStorageHandler.getSignInToken());

    _this.subscribeStateToChanges();

    _this.initializeState(config);

    return _this;
  }

  _createClass(SaleorState, null, [{
    key: "calculateSummaryPrices",
    value: function calculateSummaryPrices(checkout) {
      var _a, _b, _c;

      var items = checkout === null || checkout === void 0 ? void 0 : checkout.lines;
      var shippingMethod = checkout === null || checkout === void 0 ? void 0 : checkout.shippingMethod;
      var promoCodeDiscount = (_a = checkout === null || checkout === void 0 ? void 0 : checkout.promoCodeDiscount) === null || _a === void 0 ? void 0 : _a.discount;

      if (items && items.length) {
        var firstItemTotalPrice = items[0].totalPrice;

        if (firstItemTotalPrice) {
          var shippingPrice = Object.assign(Object.assign({}, shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.price), {
            amount: ((_b = shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.price) === null || _b === void 0 ? void 0 : _b.amount) || 0,
            currency: ((_c = shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.price) === null || _c === void 0 ? void 0 : _c.currency) || firstItemTotalPrice.gross.currency
          });
          var itemsNetPrice = items.reduce(function (accumulatorPrice, line) {
            var _a;

            return accumulatorPrice + (((_a = line.totalPrice) === null || _a === void 0 ? void 0 : _a.net.amount) || 0);
          }, 0);
          var itemsGrossPrice = items.reduce(function (accumulatorPrice, line) {
            var _a, _b;

            return accumulatorPrice + (((_b = (_a = line.totalPrice) === null || _a === void 0 ? void 0 : _a.gross) === null || _b === void 0 ? void 0 : _b.amount) || 0);
          }, 0);
          var subtotalPrice = Object.assign(Object.assign({}, firstItemTotalPrice), {
            gross: Object.assign(Object.assign({}, firstItemTotalPrice.gross), {
              amount: round_1.default(itemsGrossPrice, 2)
            }),
            net: Object.assign(Object.assign({}, firstItemTotalPrice.net), {
              amount: round_1.default(itemsNetPrice, 2)
            })
          });
          var discount = Object.assign(Object.assign({}, promoCodeDiscount), {
            amount: (promoCodeDiscount === null || promoCodeDiscount === void 0 ? void 0 : promoCodeDiscount.amount) || 0,
            currency: (promoCodeDiscount === null || promoCodeDiscount === void 0 ? void 0 : promoCodeDiscount.currency) || firstItemTotalPrice.gross.currency
          });
          var totalPrice = Object.assign(Object.assign({}, subtotalPrice), {
            gross: Object.assign(Object.assign({}, subtotalPrice.gross), {
              amount: round_1.default(itemsGrossPrice + shippingPrice.amount - discount.amount, 2)
            }),
            net: Object.assign(Object.assign({}, subtotalPrice.net), {
              amount: round_1.default(itemsNetPrice + shippingPrice.amount - discount.amount, 2)
            })
          });
          return {
            discount: discount,
            shippingPrice: shippingPrice,
            subtotalPrice: subtotalPrice,
            totalPrice: totalPrice
          };
        }
      }

      return {};
    }
  }]);

  return SaleorState;
}(helpers_1.NamedObservable);

exports.SaleorState = SaleorState;